import Network from '@/services/network'

export default function () {
    const network = new Network;

    const fetchPendingAssetRegister = (query) => {
        return network.api('get', '/asset-register/pending-asset-register' + query);
    }

    const fetchSinglePendingAssetRegister = (assetRegisterId, query) => {
        return network.api('get', '/asset-register/pending-asset-register/' + assetRegisterId + query);
    }

    const fetchAssetRegister = (query) => {
        return network.api('get', '/asset-register/asset-register' + query);
    }

    const storeAssetRegister = (data, query) => {
        return network.api('post', '/asset-register/asset-register'+query, data);
    }

    const fetchSingleAssetRegister = (assetRegisterId, query) => {
        return network.api('get', '/asset-register/asset-register/' + assetRegisterId + query);
    }

    const updateAssetRegister = (data, assetRegisterId, query) => {
        return network.api('put', '/asset-register/asset-register/'+ assetRegisterId + query, data);
    }

    const fetchAssetRegisterHistory = (assetRegisterId, query) => {
        return network.api('get', '/asset-register/asset-register/' + assetRegisterId + '/history' + query);
    }

    const disposalAssetRegister = (data, assetRegisterId, query) => {
        return network.api('put', '/asset-register/asset-register/'+ assetRegisterId + '/disposal' + query, data);
    }

    const transferAssetRegister = (data, assetRegisterId, query) => {
        return network.api('put', '/asset-register/asset-register/'+ assetRegisterId + '/transfer' + query, data);
    }

    const processDepreciation = (data, query) => {
        return network.api('post', '/asset-register/asset-register/depreciation-process' + query, data);
    }

    const fetchDepreciationRuns = (query) => {
        return network.api('get', '/asset-register/asset-register/depreciation-runs' + query);
    }

    const reprocessDepreciation = (processTrackerId, query) => {
        return network.api('put', '/asset-register/asset-register/depreciation-process/' + processTrackerId + '/reprocess' + query);
    }

    const fetchAssetScheduleReport = (query) => {
        return network.api('get', '/asset-register/asset-register/asset-schedule-report' + query);
    }

    const fetchDepreciationJournals = (query) => {
        return network.api('get', '/asset-register/asset-register/depreciation-journals' + query);
    }

    const fetchDepreciationJournalPreview = (processTrackerId, query) => {
        return network.api('get', '/asset-register/asset-register/depreciation-journals/' + processTrackerId + query);
    }

    const storeDepreciationJournal = (processTrackerId, data, query) => {
        return network.api('post', '/asset-register/asset-register/depreciation-journals/' + processTrackerId + query, data);
    }

    return {
        fetchPendingAssetRegister,
        fetchSinglePendingAssetRegister,
        storeAssetRegister,
        fetchAssetRegister,
        fetchSingleAssetRegister,
        fetchAssetRegisterHistory,
        updateAssetRegister,
        disposalAssetRegister,
        transferAssetRegister,
        processDepreciation,
        fetchDepreciationRuns,
        reprocessDepreciation,
        fetchAssetScheduleReport,
        fetchDepreciationJournals,
        fetchDepreciationJournalPreview,
        storeDepreciationJournal
    }
}